<template lang="html">
  <Layout currentMenu="Change Password">
    <LoadingSection title="Change Password" :loading="false" :autoPadding="false">
      <template v-slot:content>
        <div class="section-field">
        <SymbiumFormGroup
          label="Current Password"
          v-bind:value.sync="currentPassword"
          type="password"
          :error="errors.currentPassword"
          inputSize="change-password-input-size"
        />
        <div class="gap-3x" />

        <SymbiumPasswordForm
          v-bind:password.sync="password"
          v-bind:passwordConfirmation.sync="passwordConfirmation"
          @password-validate="validatePassword"
          inputSize="change-password-input-size"
          passwordLabel="New Password"
        />
        <div class="gap-3x" />

        <SymbiumButton
          text="Save"
          :onClick="submitData"
          :loading="submitting"
          :isDisabled="!validPassword"
          buttonSize="change-password-button-size"
        />
        <AlertSuccessModal :title="alertMessage" />
        </div>
      </template>
    </LoadingSection>
  </Layout>
</template>

<script>

import _ from 'lodash'

import EventBus from 'src/components/EventBus.js'
import LoadingSection from 'src/components/dashboard/shares/LoadingSection.vue'
import Layout from 'src/components/dashboard/shares/Layout.vue'
import SymbiumFormGroup from 'src/components/common/form/SymbiumFormGroup.vue'
import SymbiumPasswordForm from 'src/components/common/form/SymbiumPasswordForm.vue'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import AlertSuccessModal from 'src/components/common/modals/AlertSuccessModal.vue'

export default {
  components: {
    Layout, SymbiumButton, LoadingSection,
    SymbiumPasswordForm, SymbiumFormGroup, AlertSuccessModal
  },
  data() {
    return {
      submitting: false,
      currentPassword: '',
      password: '',
      errors: {},
      alertMessage: '',
      validPassword: false,
      passwordConfirmation: null,
    }
  },
  watch: {
    currentPassword() {
      this.errors.currentPassword = null
    }
  },
  methods: {
    submitData() {
      if(!this.validPassword) return;
      this.submitting = true;
      this.$user.submitChangePassword({
        currentPassword: this.currentPassword,
        password: this.password,
      })
    },
    afterSubmittedSucessfully(data) {
      this.submitting = false;
      this.errors = data.errors;
      if(_.isEmpty(this.errors, true)) {
        this.alertMessage = "Password updated";
        this.$modal.show('alert-success-modal')
      }
    },
    validatePassword(value) {
      this.validPassword = value
    }
  },
  created() {
    EventBus.$on('data-submitted-sucessfully', this.afterSubmittedSucessfully)
  },
  beforeDestroy() {
    EventBus.$off('data-submiited-sucessfully', this.afterSubmittedSucessfully)
  },
  mounted() {
    this.$user.fetchMe();
  },
}
</script>

<style lang="scss">
.change-password-input-size,
.change-password-button-size {
  width: 290px !important;

  @media screen and (max-width: 576px) {
    width: calc(100vw - 48px) !important;
  }
}
</style>
